import API from '@/api/base'
import { getTrackingKey } from '@/utils/api'

class PaymentV2API extends API {
  getPaymentExistingCards = (merchantId, paymentType, orderId) => {
    const queryParams = {
      'pm-exls': 'CheckoutApplePay',
      merchantId,
      page: 'checkout',
      productType: paymentType,
    }

    if (orderId) {
      queryParams.orderId = orderId
    }

    return this.fetcher({
      method: 'GET',
      trackingKey: getTrackingKey(this.uri, 'cards'),
      path: `${this.uri}/cards`,
      data: queryParams,
    })
  }
}

export default new PaymentV2API('/customers/payment/v2')
